import { Box } from "@chakra-ui/react";
import React from "react";
import Section1 from "../components/sections/Section1";
import SectionPerusahaan from "../components/sections/SectionPerusahaan";

export default function Homepage() {
  return (
    <Box>
      <Section1 />
      <SectionPerusahaan />
    </Box>
  );
}
